<template>
    <tr class="way_product" v-if="!way_issue">
        <td class='image_td'>
            <a :href="this.axios.defaults.baseImageURL + 'uploads/' + way_product.image" data-fancybox>
                <img class="icon" :src="this.axios.defaults.baseImageURL + 'uploads/' +  way_product.image" alt="">
            </a>
            <span class="icon_span">
                <i class="fa" :class="classname" aria-hidden="true" :title="way_product.type"></i>
            </span>
        </td>
        <td class="code">{{ way_product.week }} неделя</td>
        <td class="name">
            <a :title="way_product.name" :href="'/way-product/'+way_product.alias" target="_blank">
                <span>{{ way_product.name }}</span>
            </a>
            <span class="copyText tooltip" title="скопировать полное наименование" @click.stop.prevent="copyText">
                <i class="fa fa-files-o" aria-hidden="true"></i>
            </span>
        </td>

        <td class="remain text-center">{{ way_product.count > 50 ? 'больше 50 (шт)' : way_product.count == 0 ? 'резерв' : way_product.count + ' (шт)' }}</td>

        <td class="price text-center"></td>

        <td class="quantity">
            <div class="count">
                <button v-if="this.quantity > 1" @click="minus" class="minus">
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                </button>
                <input
                    type="number"
                    class="count_value"
                    v-model="this.quantity"
                    name="count"
                    min="1"
                >
                <button @click="plus" class="plus"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
            </div>
        </td>

        <td class="totalPrice text-center">
            <button class="reserve_btn btn btn-primary w-75 mr-4" @click="toReserve()">Зарезервировать</button>
        </td>


        <td v-if="itemDelete"><button class="btn btn-outline-danger" @click="removeProduct(way_product)"><i class="fa fa-trash-o" aria-hidden="true"></i></button></td>
    </tr>
</template>

<script>

    import Vue from 'vue';

    var $ = require("jquery");
    window.jQuery = $;
    var fancyBox = require("@fancyapps/fancybox");

    import VueClipboard from 'vue-clipboard2';

    import Swal from 'sweetalert2'

    import {mapActions, mapGetters} from 'vuex';


    Vue.use(VueClipboard);

    export default {
        props: ['way_product', 'waitingIcon', 'itemDelete'],

        data() {
            return {
                subscribe: false,
                searchChange: false,
                quantity: 1,
                classname: '',
                way_issue: false,
            }
        },

        mounted() {
            this.classname = this.way_product.type == 'Самолёт' ? 'fa-plane' : this.way_product.type == 'ЖД' ? 'fa-train' : 'fa-truck'

            if (this.way_product.subscribe_product_id) {
                this.subscribe = true;
            }

            this.axios
                .post(this.axios.defaults.baseURL + 'check-issue', {
                    'selected': 'Товары в пути'
                })
                .then(response => {
                    if(response.data.message == 'issued') {
                        this.way_issue = true
                    }
                })


            $('[data-fancybox]').fancybox({
                touch: false,
                buttons: [
                    "zoom",
                    "close",
                ],

                image: {
                    preload: true
                },

            });
        },

        methods: {

            ...mapActions({
                checkProductAction: 'checkProduct',
                checkSubscribeAction: 'checkSubscribe',
                removeProduct: 'removeProduct'
            }),

            minus: function () {
                if (this.quantity > 1) {
                    this.quantity--;
                }
            },

            plus: function () {
                if(this.quantity < this.way_product.count) {
                    this.quantity++;
                }
            },


            toReserve: function () {
                this.loading = true;

                const product = this.way_product;

                if(this.quantity > product.count || product.count === 0) {
                    Swal.fire({
                        'icon': 'error',
                        'title': `Нехватка товара для резерва. Остаток ${product.count} шт.`,
                        'showConfirmButton': false,
                        'timer': 3000,
                    });
                } else {
                    this.axios
                    .post(this.axios.defaults.baseURL + 'to-reserve/' + product.alias, {quantity: this.quantity})
                    .then(response => {
                        console.log(response)
                        if(response.status === 200){
                            Swal.fire({
                                'icon': 'success',
                                'title': 'Товар успешно отправлен в резерв',
                                'showConfirmButton': false,
                                'timer': 2500
                            })

                            this.$parent.getProducts();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            },

            checkSubscribe() {
                this.way_product.subscribe = this.subscribe
                this.checkSubscribeAction(this.way_product);
                this.subscribe = !this.subscribe;
            },

            copyText: function () {
                this.$copyText(this.way_product.name).then(function (e) {
                    console.log(e)
                }, function (e) {
                    console.log(e)
                })
            },
        },
        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        }
    }
</script>

<style lang="scss">
    @import "~@fancyapps/fancybox/dist/jquery.fancybox.min.css";

    .quantity {
        .count {
            position: relative;
            width: 125px;
            margin: 0 auto;

            display: flex;
            justify-content: center;
            align-items: center;

            .count_value {
                width: 50px;
                padding: 5px;
                margin: 0 10px;
                text-align: center;
                border: 0;
                background-color: transparent;
            }

            button {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);

                background-color: transparent;
                border: 0;
                cursor: pointer;

                i {
                    font-size: 22px;
                }

                &.minus {
                    left: 0;
                }

                &.plus {
                    right: 0;

                    i {
                        &::before {
                            color: green;
                        }
                    }
                }
            }
        }
    }

    .totalPrice {
        min-width: 125px;
    }


    .border-bottom {
        border-bottom: 1px solid red;
    }

    .name {
        width: 30%;
    }

    .jBox-Tooltip {
        .jBox-container {
            .jBox-content {
                max-width: 300px;
                padding: 5px 10px;
                font-size: 12px;
                text-align: center;
            }
        }
    }

    .alarm {
        background-color: transparent;
        border: 0;
        cursor: pointer;

        &.active {
            color: red;
        }

        i {
            &:before {
                font-size: 18px;
            }
        }
    }

    .image_td {
        display: flex;
        align-items: center;
        padding: 0;

        a {
            width: 50%;
            height: 100%;
        }
        .icon {
            margin: 0;
        }

        .icon_span {
            width: 50%;
            display: flex;
            justify-content: center;
        }
        
        i {
            font-size: 25px;
        }
    }

    .way_product {
        background: rgb(255, 206, 0);
    }

    .quantity .count{
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/WayProduct.vue